import { ConfigService } from '@maia/config';
import { HttpService } from '@maia/httpClient';
import {
  CancellationService,
  CartService,
  MutationService,
} from '@maia/shared';
import { CartController } from './cart.controller';

export class ServiceFactory {
  private readonly configService = new ConfigService();
  private readonly httpService = new HttpService(this.configService, 'apiUrl');

  createCartController(): CartController {
    return new CartController(
      this.createCartService(),
      this.createMutationService(),
      this.createCancellationService(),
    );
  }

  private createCartService() {
    return new CartService(this.httpService, this.configService);
  }

  private createMutationService() {
    return new MutationService(this.httpService, this.configService);
  }

  private createCancellationService() {
    return new CancellationService(this.httpService, this.configService);
  }
}

const factory = new ServiceFactory();
export const service = factory.createCartController();
